export default __webpack_public_path__ + "static/media/Good.a6d49b39.mp3";